export const isMainPage = window.location.pathname === '/' || window.location.pathname === '/index.html';

const getElement = <T extends HTMLElement>(id: string): T | null => document.getElementById(id) as T | null;

export const uiGetAuthContainer = (): HTMLDivElement | null => getElement<HTMLDivElement>('firebaseui-auth-container');

export const uiSetAuthTemplate = (): HTMLButtonElement | null => {
  const container = uiGetAuthContainer();
  if (!container || !isMainPage) return null;
  container.classList.remove('google-identity-button-host');
  container.replaceChildren();
  const button = document.createElement('button');
  button.type = 'button';
  button.className = 'logmein';
  button.setAttribute('aria-label', 'Continue with Google');
  const icon = document.createElement('img');
  icon.className = 'firebaseui-idp-icon';
  icon.alt = '';
  icon.src = 'https://www.gstatic.com/firebasejs/ui/2.0.0/images/auth/google.svg';
  const label = document.createElement('span');
  label.textContent = 'Continue with Google';
  button.append(icon, label);
  container.appendChild(button);
  return button;
};

export const uiSetLoginBusy = (busy: boolean, message = ''): void => {
  const button = document.querySelector<HTMLButtonElement>('button.logmein');
  if (button) {
    button.disabled = busy;
    button.setAttribute('aria-busy', String(busy));
  }
  const status = getElement<HTMLDivElement>('login-status-message');
  if (status) status.textContent = message;
};

export const uiResetLoginError = (): void => {
  const element = getElement<HTMLDivElement>('login-error-message');
  if (!element) return;
  element.textContent = '';
  element.hidden = true;
};

export const uiDisplayErrorMessage = (message: string): void => {
  const element = getElement<HTMLDivElement>('login-error-message');
  if (!element) return;
  element.textContent = message;
  element.hidden = false;
};
